module.exports = __webpack_public_path__ + "img/img3.7aed37a1.svg";